var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolticon = function SvgBolticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m8.055 18.055 2.223-7.777H4.962a.555.555 0 0 1-.521-.747l2.648-7.222a.556.556 0 0 1 .52-.365h4.634c.391 0 .659.393.518.757l-1.65 4.243h4.167c.457 0 .718.523.444.89L8.055 18.054Z"
  })));
};
export default SvgBolticon;